"use client"

import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { useCart } from "../CartContent"
import Navbar from "./Components/Navbar"
import Footer from "./Components/Footer"
import { CheckCircle } from "lucide-react" // Using Lucide React for an icon
import DeliveryModal from "./Components/DeliveryModal"

const Receipt = () => {
    const { clearCart } = useCart()
    const [showMenuModal, setShowMenuModal] = useState(false)

    useEffect(() => {
        // Clear the cart once the receipt page is loaded after a successful checkout
        clearCart()
    }, [clearCart])

    return (
        <div className="bg-[#F5F5DC] min-h-screen flex flex-col">
            {/* Navbar - Pass 0 for totalQuantity as cart should be cleared */}
            <Navbar totalQuantity={0} />

            <section className="flex-grow w-full px-4 sm:px-6 md:px-8 lg:px-16 py-12 md:py-20 bg-orange-400 flex items-center justify-center">
                <div className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-xl text-center flex flex-col items-center gap-6">
                    <CheckCircle className="w-20 h-20 text-green-600" />
                    <h1 className="text-3xl md:text-4xl font-bold text-black">Order Complete!</h1>
                    <p className="text-lg md:text-xl text-gray-800">
                        Your payment has been successfully received. Thank you for your order!
                    </p>
                    <p className="text-md text-gray-600">You will receive an email confirmation shortly.</p>
                    <div className="flex flex-col sm:flex-row gap-4 mt-6">
                        <button
                            type="button"
                            onClick={() => setShowMenuModal(true)}
                            className="px-6 py-3 bg-black text-white text-base font-medium rounded-lg hover:bg-gray-800 transition"
                        >
                            Browse More Items
                        </button>
                        <Link
                            to="/"
                            onClick={() => console.log("Clicked Back to Home")}
                            className="px-6 py-3 border border-black text-black text-base font-medium rounded-lg hover:bg-black hover:text-white transition"
                        >
                            Back to Home
                        </Link>
                    </div>
                </div>
            </section>

            <Footer />

            <DeliveryModal isOpen={showMenuModal} onClose={() => setShowMenuModal(false)} pickupPath="/menu" />
        </div>
    )
}

export default Receipt
